export default __webpack_public_path__ + "static/media/customer-icon.f6db6144.svg";